<template>
    <div class="sharePaymentLink">
        <div class="sharePaymentLink_container">
            <!-- Não Logado -->
            <template v-if="!user.isLogged">
                <div class="sharePaymentLink_content_header">
                    <img src="../assets/builderall-logo-name.svg" alt="Builderall" title="Builderall" class="sharePaymentLink_logo" />
                </div>
                <AccountNotLoggedIn :onlyLogin="true" @new-register:login-success="onLoginSuccess" />
            </template>

            <!-- Logado -->
            <template v-if="user.isLogged">
                <div class="sharePaymentLink_content">
                    <div class="sharePaymentLink_content_header">
                        <img src="../assets/builderall-logo-name.svg" alt="Builderall" title="Builderall" class="sharePaymentLink_logo" />
                        <h1 class="sharePaymentLink_content_title">{{ translateWord('Efetuar Pagamento') }}</h1>
                    </div>

                    <div class="sharePaymentLink_content_user">
                        <p>{{ translateWord('Olá') }}, <strong>{{ user.name }}</strong></p>
                        <p class="sharePaymentLink_content_user_plan">
                            {{ translateWord('Plano atual') }}: <strong>{{ user.current_plan ? user.current_plan.title : '-' }}</strong>
                        </p>
                    </div>

                    <!-- Botão para ir ao checkout -->
                    <div class="sharePaymentLink_content_actions">
                        <a :href="paymentLink" class="sharePaymentLink_content_actions_btn sharePaymentLink_content_actions_btn--primary">
                            <i class="icon icon-shopping-cart"></i>
                            {{ translateWord('Ir para o Checkout') }}
                        </a>
                    </div>

                    <!-- Link para compartilhar -->
                    <div class="sharePaymentLink_content_link">
                        <label>{{ translateWord('Ou copie o link para compartilhar') }}:</label>
                        <div class="sharePaymentLink_content_link_input">
                            <input type="text" readonly :value="paymentLink" ref="linkInput" />
                            <button @click="copyLink" class="sharePaymentLink_content_link_btn">
                                <i class="icon icon-copy"></i>
                                {{ translateWord('Copiar') }}
                            </button>
                        </div>
                    </div>

                    <div v-if="copied" class="sharePaymentLink_content_copied">
                        <i class="icon icon-check"></i> {{ translateWord('Link copiado com sucesso!') }}
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Helper from '../assets/js/helper';
import { mapState, mapGetters } from 'vuex';

import AccountNotLoggedIn from '../components/User/AccountNotLoggedIn';

export default {
    name: "SharePaymentLink",
    data() {
        return {
            copied: false
        }
    },
    computed: {
        ...mapState([
            'user'
        ]),
        ...mapGetters([
            'translateWord'
        ]),
        paymentLink() {
            const baseUrl = Helper.getEnvs().env === 'dev' ? 'http://' : 'https://';
            const domain = Helper.getEnvs().urlCheckoutFront;
            const slug = this.user.current_plan && this.user.current_plan.slug ? this.user.current_plan.slug : '';
            return `${baseUrl}${domain}/payment/${slug}`;
        }
    },
    methods: {
        async copyLink() {
            try {
                await this.$copyText(this.paymentLink);
                this.copied = true;

                setTimeout(() => {
                    this.copied = false;
                }, 3000);
            } catch (error) {
                console.error('Erro ao copiar link:', error);
            }
        },
        onLoginSuccess() {
            window.location.reload();
        }
    },
    components: {
        AccountNotLoggedIn
    }
}
</script>

<style lang="scss">
.sharePaymentLink {
    min-height: 100vh;
    background: var(--gray-50, #f5f5f5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.sharePaymentLink_container {
    width: 100%;
    max-width: 500px;
    background: var(--white, #fff);
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 30px;
}

.sharePaymentLink_content_header {
    text-align: center;
    margin-bottom: 30px;
}

.sharePaymentLink_logo {
    max-width: 140px;
    height: auto;
    margin-bottom: 15px;
}

.sharePaymentLink_content_title {
    font-size: 1.5em;
    color: var(--black, #333);
    margin: 0;
}

.sharePaymentLink_content_user {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--gray-100, #e9e9e9);

    & p {
        margin: 5px 0;
        font-size: 1em;
    }
}

.sharePaymentLink_content_user_plan {
    font-size: 0.9em !important;
    color: var(--gray-500, #666);
}

.sharePaymentLink_content_actions {
    margin-bottom: 30px;
}

.sharePaymentLink_content_actions_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 15px 20px;
    border-radius: 5px;
    font-weight: 600;
    font-size: 1.1em;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s;

    &--primary {
        background: var(--blue, #1869F6);
        color: var(--white, #fff);
        border: none;

        &:hover {
            background: darken(#1869F6, 10%);
            color: var(--white, #fff);
        }
    }

    & .icon {
        font-size: 1.2em;
    }
}

.sharePaymentLink_content_link {
    margin-bottom: 20px;
    padding-top: 20px;
    border-top: 1px solid var(--gray-100, #e9e9e9);

    & label {
        display: block;
        margin-bottom: 10px;
        font-weight: 600;
        color: var(--gray-500, #666);
        font-size: 0.9em;
    }
}

.sharePaymentLink_content_link_input {
    display: flex;
    gap: 10px;

    & input {
        flex: 1;
        padding: 12px 15px;
        border: 1px solid var(--gray-100, #e9e9e9);
        border-radius: 5px;
        font-size: 0.9em;
        color: var(--gray-500, #666);
        background: var(--gray-50, #f5f5f5);
    }
}

.sharePaymentLink_content_link_btn {
    padding: 12px 20px;
    background: var(--blue, #1869F6);
    color: var(--white, #fff);
    border: none;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s;

    &:hover {
        background: darken(#1869F6, 10%);
    }

    & .icon {
        font-size: 1em;
    }
}

.sharePaymentLink_content_copied {
    text-align: center;
    color: #3fd1ae;
    font-weight: 600;
    padding: 10px;
    background: rgba(63, 209, 174, 0.1);
    border-radius: 5px;

    & .icon {
        margin-right: 5px;
    }
}

@media (max-width: 767px) {
    .sharePaymentLink_content_link_input {
        flex-direction: column;
    }

    .sharePaymentLink_content_link_btn {
        justify-content: center;
    }
}
</style>
